import styled, { css } from 'styled-components'

import { palette } from '_styles/variables'

import { getFontSize } from '../functions'

interface Props {
  isDisabled?: boolean
  size?: number | string
}

export const IconWrapper = styled.svg<{
  iconColor?: string
  size?: number | string
}>`
  font-size: ${({ size }) => getFontSize(size)};
  color: ${({ iconColor }) => iconColor || 'inherit'};
  min-height: 1em;
  height: 1em;
  width: auto;
`

export const ClickableIconWrapper = styled.button.attrs(() => ({
  role: 'button',
}))<Props>`
  padding: 0;
  border: none;
  display: flex;
  height: max-content;
  font-size: inherit;
  background-color: transparent;
  color: ${palette.neutral['grey-icons']};
  cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      pointer-events: none;
      color: ${palette.neutral['grey-bbbdbf']};
    `}
`
